export const CONNECTION_GAMES = [];
